import React from "react";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f0f0;
  min-height: 300px;
  animation: ${fadeIn} 0.3s ease-out;
`;

const ErrorIcon = styled.div`
  width: 64px;
  height: 64px;
  background: #fee2e2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  &::before {
    content: "⚠️";
    font-size: 24px;
  }
`;

const ErrorTitle = styled.h3`
  color: #dc2626;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  text-align: center;
`;

const ErrorMessage = styled.p`
  color: #6b7280;
  font-size: 0.875rem;
  text-align: center;
  margin: 0 0 1.5rem 0;
  max-width: 300px;
  line-height: 1.5;
`;

const RetryButton = styled.button`
  background: #3b82f6;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #2563eb;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

const HeroCardError = ({ error, onRetry }) => {
  return (
    <ErrorContainer>
      <ErrorIcon />
      <ErrorTitle>Failed to Load Strategy</ErrorTitle>
      <ErrorMessage>
        {error?.message ||
          "Something went wrong while loading the strategy data. Please try again."}
      </ErrorMessage>
      {onRetry && <RetryButton onClick={onRetry}>Try Again</RetryButton>}
    </ErrorContainer>
  );
};

HeroCardError.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  onRetry: PropTypes.func,
};

HeroCardError.defaultProps = {
  error: null,
  onRetry: null,
};

export default HeroCardError;
